import {useQueryParam, StringParam} from 'use-query-params'

export const useGetHeroExtension = (extensions) => {
  const [extInParam] = useQueryParam('ext', StringParam)
  const extension = extensions.find((extension) => extension.tag === extInParam) || extensions[0]

  return extension
}
